import { useEffect, useRef, useCallback } from "react";
// services
// import Glient from "../services/glient";
import Gupport from "../services/gupport";
// import CC from "../services/cc";
// types
import type Constants from "../services/constants";
import type { HandlerId, PayloadTxKnown, RxCallback } from "../types/roc-ws";

type WT = typeof Constants.WsType.Gupport;

const useSend = () => {
	const handlerIdRef = useRef(new Set<HandlerId>());

	const send = useCallback(<P extends PayloadTxKnown<WT>>(cmd: P, callback?: RxCallback<WT, P>, timeout: number = 30000) => {
		const handlerId = Gupport.send(cmd, (error, msg) => {
			handlerIdRef.current.delete(handlerId);
			callback?.(error, msg);
		}, timeout);
		handlerIdRef.current.add(handlerId);
	}, []);

	useEffect(() => (
		() => {
			for (const handlerId of handlerIdRef.current) {
				Gupport.abort(handlerId);
			}
			handlerIdRef.current.clear();
		}
	), []);

	return send;
};

export default useSend;
